module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_7016.60e0031b.png";